import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        v2TextTitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.inverse',
        },
        v2BadgeLabel: {
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            mb: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            pb: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            alignItems: 'center',
        },
        ctas: {
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            flexDirection: {base: 'column', md: 'row'},
            alignItems: {base: 'center', md: 'flex-start'},
            flexWrap: {base: 'wrap', lg: 'nowrap'},
            pb: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        v2TextTitleMain: {
            fontWeight: 'light',
            textStyle: 'head-xlarge',
        },
        HeroBannerButton: {
            minW: {base: remCalc(227), md: remCalc(310), lg: remCalc(213)},
        },
        v2HeroBannerButton: {
            minW: 'auto',
            maxW: '100%',
            lineHeight: 1,
            alignItems: 'center',
            justifyContent: 'center',
        },
        v2CarouselBar: {
            w: '100%',
            pt: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.md', 'xxsmall-1.lg'],
            px: {base: 'xsmall', lg: 0},
            alignItems: 'center',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        v2CarouselTrack: {
            flex: 1,
            h: '4px',
            bg: 'background.neutral.white',
            borderRadius: 'full',
            overflow: 'hidden',
        },
        v2CarouselFill: {
            h: '100%',
            bg: '#efedea',
            transition: 'width linear',
        },
        v2CarouselArrow: {
            variant: 'ghost',
            color: '#efedea',
            flexShrink: 0,
            minW: 'auto',
            boxSize: remCalc(28),
            size: 'small',
        },
        alignment: {
            'top-center': {
                container: {
                    layerStyle: 'page',
                    alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    marginTop: remCalc(40),
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-right': {
                container: {
                    layerStyle: 'page',
                    alignItems: 'center',
                    justifyContent: {base: 'center', sm: 'center', md: 'center', lg: 'flex-end'},
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: {base: '100%', lg: remCalc(688)},
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'bottom-center': {
                container: {
                    layerStyle: 'page',
                    alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'flex-end'},
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: '100%',
                    marginBottom: {
                        base: 'xxsmall-1.base',
                        md: 'xxsmall-1.md',
                        lg: 'xxsmall-1.lg',
                        xl: 'xxsmall-1.xl',
                    },
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-left': {
                container: {
                    layerStyle: 'page',
                    alignItems: 'center',
                    justifyContent: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: {base: '100%', lg: remCalc(688)},
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'middle-center': {
                container: {
                    layerStyle: 'page',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: 'column',
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
            'bottom-left': {
                container: {
                    layerStyle: 'page',
                    alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'flex-end'},
                    justifyContent: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
                    width: '100%',
                    zIndex: 1,
                },
                textContent: {
                    width: {base: '100%', lg: remCalc(688)},
                    flexDirection: 'column',
                    marginBottom: {
                        base: 'xxsmall-1.base',
                        md: 'xxsmall-1.md',
                        lg: 'xxsmall-1.lg',
                        xl: 'xxsmall-1.xl',
                    },
                    px: {base: remCalc(0), md: remCalc(24), lg: remCalc(0)},
                },
            },
        },
    },
    variants: {
        white: {
            v2CarouselArrow: {color: '#efedea'},
        },
        black: {
            v2CarouselArrow: {color: '#efedea'},
        },
    },
}
